export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGOUT";
export const USER_SUCCESS = "USER_SUCCESS";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const SET_CURRENT_SEASON = "SET_CURRENT_SEASON";
export const SET_SELECTED_MENU_ITEM = "SET_SELECTED_MENU_ITEM";
export const SET_PLAYER_TAB = "SET_PLAYER_TAB";
export const SET_TEAM_TAB = "SET_TEAM_TAB";
export const SET_MATCH_TAB = "SET_MATCH_TAB";
export const SET_TRAINING_TAB = "SET_TRAINING_TAB";

export const loginSuccess = (token) => ({
	type: LOGIN_SUCCESS,
	payload: token,
});

export const logout = () => ({
	type: LOGOUT,
});

export const userSuccess = (payload) => ({
	type: USER_SUCCESS,
	payload,
});

export const setLanguage = (payload) => ({
	type: SET_LANGUAGE,
	payload,
});

export const setCurrentSeason = (payload) => ({
	type: SET_CURRENT_SEASON,
	payload,
});

export const setSelectedMenuItem = (selectedMenuItem) => ({
	type: SET_SELECTED_MENU_ITEM,
	payload: selectedMenuItem,
});

export const setPlayerTab = (playerTab) => ({
	type: SET_PLAYER_TAB,
	payload: playerTab,
});

export const setTeamTab = (teamTab) => ({
	type: SET_TEAM_TAB,
	payload: teamTab,
});

export const setMatchTab = (matchTab) => ({
	type: SET_MATCH_TAB,
	payload: matchTab,
});

export const setTrainingTab = (matchTab) => ({
	type: SET_TRAINING_TAB,
	payload: matchTab,
});
